import { GAME_NAME } from "./constants.ts";

export const DEFAULT_TRAGIC_DEATH_REASON_TO_KEY: Record<string, string> = {
	"PLAYER_NAME died from a drug overdose.": "tragicDeath.drugOverdose",
	"PLAYER_NAME was killed by a gunshot during an altercation at a night club.":
		"tragicDeath.nightClubGunshot",
	"PLAYER_NAME was eaten by wolves. PRONOUN_He was delicious.":
		"tragicDeath.eatenByWolves",
	"PLAYER_NAME died in a car crash.": "tragicDeath.carCrash",
	"PLAYER_NAME was stabbed to death by a jealous ex-girlfriend.":
		"tragicDeath.stabbedByEx",
	"PLAYER_NAME committed suicide.": "tragicDeath.suicide",
	"PLAYER_NAME died from a rapidly progressing case of ebola.":
		"tragicDeath.ebola",
	"PLAYER_NAME was killed in a bar fight.": "tragicDeath.barFight",
	"PLAYER_NAME died after falling out of PRONOUN_his 13th floor hotel room.":
		"tragicDeath.hotelFall",
	"PLAYER_NAME was shredded to bits by the team plane's propeller.":
		"tragicDeath.planePropeller",
	"PLAYER_NAME was hit by a stray meteor.": "tragicDeath.strayMeteor",
	"PLAYER_NAME accidentally shot PRONOUN_himself in the head while cleaning PRONOUN_his gun.":
		"tragicDeath.cleaningGun",
	"PLAYER_NAME was beheaded by ISIS.": "tragicDeath.beheaded",
	"PLAYER_NAME spontaneously combusted.": "tragicDeath.combusted",
	"PLAYER_NAME had a stroke after reading about the owner's plans to trade PRONOUN_him.":
		"tragicDeath.strokeAfterTradeRumor",
	"PLAYER_NAME died of exertion while trying to set the record for largest number of sex partners in one day.":
		"tragicDeath.exertionRecord",
	"PLAYER_NAME rode PRONOUN_his Segway off a cliff.":
		"tragicDeath.segwayCliff",
	"PLAYER_NAME fell into the gorilla pit at the zoo and was dismembered as the staff decided not to shoot the gorilla.":
		"tragicDeath.gorillaPit",
	"PLAYER_NAME was pursued by a bear, and mauled.":
		"tragicDeath.bearMauled",
	"PLAYER_NAME was smothered to death by a throng of ravenous, autograph-seeking fans after exiting the team plane.":
		"tragicDeath.autographFans",
	"PLAYER_NAME suffered a heart attack in the team training facility and died.":
		"tragicDeath.trainingFacilityHeartAttack",
	"PLAYER_NAME was lost at sea and is presumed dead.":
		"tragicDeath.lostAtSea",
	"PLAYER_NAME was run over by a car.": "tragicDeath.hitByCar",
	"PLAYER_NAME was run over by a car, and then was run over by a second car. Police believe only the first was intentional.":
		"tragicDeath.hitByTwoCars",
	"PLAYER_NAME cannot be found and is presumed dead. Neighbors reported strange lights in the sky above PRONOUN_his house last night.":
		"tragicDeath.presumedDeadStrangeLights",
	"PLAYER_NAME fell off the edge of the flat earth.":
		"tragicDeath.flatEarthEdge",
	"PLAYER_NAME died a normal death. Move on, find a new slant.":
		"tragicDeath.normalDeath",
	"PLAYER_NAME was shot by police while shoplifting in China.":
		"tragicDeath.shopliftingChina",
	"PLAYER_NAME died from an adult onset peanut allergy while eating PRONOUN_his pre-game PB&J sandwich.":
		"tragicDeath.peanutAllergy",
	"PLAYER_NAME fell into a wood chipper.": "tragicDeath.woodChipper",
	"PLAYER_NAME was killed in swatting attack during a heated game of Fortnite.":
		"tragicDeath.swattingFortnite",
	"PLAYER_NAME choked to death on a pretzel.":
		"tragicDeath.pretzel",
	"PLAYER_NAME was murdered by a time traveler so PRONOUN_he would not become the world's evil overlord following PRONOUN_his playing days.":
		"tragicDeath.timeTraveler",
	'PLAYER_NAME removed the "Do Not Remove" tag from a newly purchased mattress and was promptly devoured by mattress gnomes':
		"tragicDeath.mattressGnomes",
	"PLAYER_NAME died of dysentery.": "tragicDeath.dysentery",
	"PLAYER_NAME was strangled to death by a teammate for not knowing the score late in a close game.":
		"tragicDeath.teammateStrangled",
	"PLAYER_NAME died in a freak gasoline fight accident.":
		"tragicDeath.gasolineFight",
	[`PLAYER_NAME was intensely focused on playing ${GAME_NAME} on PRONOUN_his cell phone. As PRONOUN_he walked across the street, PRONOUN_he was so distracted by PRONOUN_his ultimately fatal obsession that PRONOUN_he didn't notice the bus barreling towards PRONOUN_him.`]:
		"tragicDeath.phoneBus",
	"PLAYER_NAME drowned while crossing the Saleph River.":
		"tragicDeath.salephRiver",
	"PLAYER_NAME uploaded PRONOUN_himself to the cloud and can no longer participate in corporeal pursuits.":
		"tragicDeath.uploadedToCloud",
	"PLAYER_NAME committed suicide by two shots to the back of PRONOUN_his head after handcuffing and throwing PRONOUN_himself into the ocean inside a duffle bag, CIA reports.":
		"tragicDeath.ciaReports",
	"PLAYER_NAME fell to PRONOUN_his death while testing PRONOUN_his homemade parachute.":
		"tragicDeath.parachute",
	"PLAYER_NAME was killed by a falling coconut while relaxing at the beach.":
		"tragicDeath.coconut",
	"PLAYER_NAME died after eating way too many Brazil nuts and overdosing on selenium.":
		"tragicDeath.brazilNuts",
	"PLAYER_NAME drowned after falling into a vat of chocolate during a factory tour.":
		"tragicDeath.chocolateVat",
	"PLAYER_NAME accidentally shot himself in the head after slipping on a banana peel while walking down the stairs.":
		"tragicDeath.bananaPeelGun",
	"PLAYER_NAME died from a skull fracture after hitting PRONOUN_his head on the rim while practicing for a dunk contest.":
		"tragicDeath.dunkContestRim",
	"PLAYER_NAME fell to PRONOUN_his death after slapping the backboard of a hoop inexplicably placed in front of a flimsy window on the 3rd floor of a building.":
		"tragicDeath.backboardWindow",
};

export const getDefaultTragicDeathTextKey = (reason: string) =>
	DEFAULT_TRAGIC_DEATH_REASON_TO_KEY[reason];
